import { DatePickerInput } from "@/components/ui";
import { formatIso, parseIso } from "@/features/datos-generales/utils/iso-date";

interface Props {
  inicio: string;
  fin: string;
  inicioError?: string;
  finError?: string;
  soloLectura: boolean;
  onInicioChange: (iso: string) => void;
  onFinChange: (iso: string) => void;
}

/**
 * Dos DatePickerInput lado a lado para el periodo · presentacional.
 * Encapsula el parseo ISO ↔ Date para que el form solo maneje strings.
 */
export function PeriodoServicioFields({ inicio, fin, inicioError, finError, soloLectura, onInicioChange, onFinChange }: Props) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <DatePickerInput
        label="Inicio del periodo"
        placeholder="Selecciona la fecha…"
        required
        clearable={!soloLectura}
        disabled={soloLectura}
        value={parseIso(inicio)}
        onChange={(d) => onInicioChange(formatIso(d))}
        error={inicioError}
      />
      <DatePickerInput
        label="Fin del periodo"
        placeholder="Selecciona la fecha…"
        required
        clearable={!soloLectura}
        disabled={soloLectura}
        value={parseIso(fin)}
        onChange={(d) => onFinChange(formatIso(d))}
        error={finError}
      />
    </div>
  );
}
